import { render } from "./UIError.vue?vue&type=template&id=69e94d82&scoped=true&ts=true"
import script from "./UIError.vue?vue&type=script&lang=ts"
export * from "./UIError.vue?vue&type=script&lang=ts"

import "./UIError.vue?vue&type=style&index=0&id=69e94d82&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69e94d82"]])

export default __exports__